'use client'

import SignIn from '@/templates/SignInPage/Form/SignIn'

/** Sign-in card: centred heading, then the form (which carries its own sign-up footer). */
const SignInPage = () => (
  <div className="w-full">
    <div className="mb-6 flex flex-col items-center gap-1 text-center">
      <h1 className="text-[22px] font-medium leading-[1.3] tracking-[-0.3px] text-ink">
        Welcome back
      </h1>
      <p className="text-[14px] leading-[1.4] tracking-[-0.2px] text-ink-3">
        Sign in to open your LiveContact dashboard.
      </p>
    </div>
    <SignIn />
  </div>
)

export default SignInPage
